import { useEffect, useState, useCallback } from "react";
import { getDocumentURL } from "../utils/ConstantsURL";

export const useFetchDocument = (token) => {
  const [document, setDocument] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response = await fetch(getDocumentURL(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      let data = await response.json();
      if (response.ok) {
        setDocument(data);
        setLoading(false);
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { document, loading, refetch: fetchData };
};
